<template>
  <div
    v-if="currentCard"
    class="editor-container"
    :style="editorType === 'testimonial-card-editor' ? 'max-width: 100%' : ''"
  >
    <div v-if="newTestimonialCardAddition" class="selector-background">
      <div class="new-card-selector p-8">
        <div name="card-type-selector-container">
          <div
            id="card-with-link"
            class="p4 card-item"
            @click="handleNewCardSelection"
          >
            Card with link
          </div>
          <div
            id="card-with-button"
            class="p4 card-item"
            @click="handleNewCardSelection"
          >
            Card with button
          </div>
          <div
            id="student-card"
            class="p4 card-item"
            @click="handleNewCardSelection"
          >
            Student Testimonial Card
          </div>
          <div
            id="plain-text-card"
            class="p4 card-item"
            @click="handleNewCardSelection"
          >
            Simple text card
          </div>
        </div>
        <div
          class="flex flex-row flex-no-wrap justify-around"
          style="max-width: 620px;margin: auto;"
        >
          <button
            class="btn w-auto btn-warn"
            @click="newTestimonialCardAddition = false"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
    <div class="btns-container">
      <div class="left absolute">
        <div
          :style="cardIndex === 0 ? 'color: lightgrey;' : ''"
          class="block select-none btn-icon"
          title="Previous card"
          @click="goToPreviousCard"
        >
          &#x2190;
        </div>
        <div
          class="block select-none btn-icon"
          title="Add New card on the left side of the current card"
          @click="prepareNewCard('left')"
        >
          &#x2b;
        </div>
      </div>
      <div class="right select-none absolute">
        <div
          :style="cardIndex === allCards.length - 1 ? 'color: lightgrey;' : ''"
          class="block select-none btn-icon"
          title="Next card"
          @click="goToNextCard"
        >
          &#x2192;
        </div>
        <div
          class="block select-none btn-icon"
          title="Add New card on the right side of the current card"
          @click="prepareNewCard('right')"
        >
          &#x2b;
        </div>
      </div>
    </div>
    <div v-if="currentCard" class="input-boxes">
      <div class="pagination-container">
        <button
          v-for="(card, idx) in allCards"
          :key="idx"
          :style="
            cardIndex === idx ? 'background-color: darkgrey; color: white;' : ''
          "
          class="item-no"
          :title="
            cardIndex === idx ? 'Current Card' : `Go to card no ${idx + 1}`
          "
          @click="setAsCurrentCard(idx)"
        >
          {{ idx + 1 }}
        </button>
      </div>
      <form
        v-if="editorType === 'youtube-session-editor'"
        @submit.prevent="handleSubmit"
      >
        <input
          id="title"
          v-model="currentCard.title"
          placeholder="Enter video title"
          type="text"
          name="title"
          title="Add title of your YouTube video"
        />
        <input
          id="link"
          v-model="currentCard.link"
          placeholder="Enter video link"
          type="url"
          name="youtube-url"
          title="Paste YoutTube video link here"
        />
        <div class="thumbnail-preview">
          <!-- to support old cloudinary links -->
          <img
            v-if="!currentCard.thumbnail.startsWith('https')"
            :src="
              currentCard.thumbnail !== ''
                ? `https://res.cloudinary.com/edyst/image/upload/${currentCard.thumbnail}`
                : '/images/placeholders/youtube-thumbnail-placeholder-for-admin-app.png'
            "
            alt="thumbnail preview"
          />
          <!-- markup for new aws s3 links -->
          <img
            v-if="currentCard.thumbnail.startsWith('https')"
            :src="
              currentCard.thumbnail !== ''
                ? currentCard.thumbnail
                : '/images/placeholders/youtube-thumbnail-placeholder-for-admin-app.png'
            "
            alt="thumbnail preview"
          />
        </div>
        <button
          class="rm-card-btn btn btn-warn block bg-red text-center leading-normal rounded-sm cursor-pointer text-white block p-2 m-auto"
          title="Remove this card from carousel."
          @click.prevent="removeCard"
        >
          Delete
        </button>
        <button
          class="img-upload-btn block m-auto p-2 btn"
          :disabled="!currentCard.title || !currentCard.link"
          title="Upload thumbnail"
          @click.prevent="prepareCloudinaryWidget(currentCard.link)"
        >
          <img
            src="https://res.cloudinary.com/edyst/image/upload/v1562675152/admin-page/image-upload_kgluvk.png"
            class="img-upload-logo"
          />
          Upload Thumbnail
        </button>
        <div class="flex">
          <button
            v-if="editorType === 'youtube-session-editor'"
            :disabled="
              !currentCard.title || !currentCard.link || !currentCard.thumbnail
            "
            class="preview-btn block m-auto p-2 btn"
            title="Preview on the carousel"
          >
            <img
              src="https://res.cloudinary.com/edyst/image/upload/v1562677361/admin-page/preview.svg"
              class="img-upload-logo"
            />
            Web Preview
          </button>
          <button
            v-if="editorType === 'youtube-session-editor'"
            :disabled="
              !currentCard.title || !currentCard.link || !currentCard.thumbnail
            "
            class="preview-btn block m-auto p-2 btn"
            title="Preview on the carousel"
            @click.prevent="$emit('MOBILE_PREVIEW', allCards)"
          >
            <img
              src="https://res.cloudinary.com/edyst/image/upload/v1562748022/admin-page/mobile-icon.png"
              class="img-upload-logo"
            />
            Mobile Preview
          </button>
        </div>
      </form>

      <!-- testimonial carousel update form  -->
      <form v-if="editorType === 'testimonial-card-editor'">
        <div class="card-selector">
          <label for="card-type-changer">Change card type</label>
          <select
            id="card-type-changer"
            v-model="testimonialCardType"
            name="card type selector"
            class="block mt-1"
            title="Change current card type, please note that based on card type you select, some fields will be removed."
            @change="handleCardTypeChange"
          >
            <option selected value="card-with-link">Card with link</option>
            <option value="card-with-button">Card with button</option>
            <option value="student-card">Student Testimonial Card</option>
            <option value="plain-text-card">Simple text card</option>
          </select>
        </div>
        <label for="title">{{
          currentCard.type === "student-card"
            ? "Student's name"
            : "Title of the card"
        }}</label>
        <input
          v-model="currentCard.heading"
          type="text"
          name="title"
          :title="
            currentCard.type === 'student-card'
              ? 'Full name of the student'
              : 'Title of the card'
          "
          :placeholder="
            currentCard.type === 'student-card'
              ? 'Name of the student'
              : 'Title of the card'
          "
        />
        <label for="description"
          >{{
            currentCard.type === "student-card" ? "Testimonial" : "Description"
          }}
          <small
            v-if="getDescriptionLength(currentCard.description)"
            class="ml-4 text-red"
            >Content is more than the recommended 300 characters</small
          ></label
        >

        <textarea
          v-model.trim="currentCard.description"
          :style="
            `border: ${
              getDescriptionLength(currentCard.description)
                ? ' 1px solid red;'
                : '1px solid white;'
            }`
          "
          name="description"
          cols="30"
          rows="5"
          :title="
            `Add ${
              currentCard.type === 'student-card'
                ? 'Testimonial'
                : 'Description'
            } here.`
          "
          :placeholder="
            currentCard.type === 'student-card' ? 'Testimonial' : 'Description'
          "
          @blur="
            getDescriptionLength(currentCard.description) &&
              $noty.warning(
                'Description is more than the recommended 300 characters'
              )
          "
        ></textarea>
        <div v-if="currentCard.externalLink !== undefined">
          <label for="link">Add link</label>
          <input
            v-model="currentCard.externalLink"
            type="url"
            name="link"
            placeholder="External link"
            title="Add external link here, it will open in a new tab."
            class="block"
          />
        </div>
        <div v-if="currentCard.additionalInfo !== undefined">
          <label for="additional-info">Additional Text Info</label>
          <input
            id="additional-info"
            v-model="currentCard.additionalInfo"
            type="text"
            name="additional-info"
            title="Add additional info here, it will be visible at the end of description."
            placeholder="Addition info"
          />
        </div>
        <div v-if="currentCard.buttonLink !== undefined">
          <label for="button-link"
            >Course link
            <small class="text-red ml-2"
              >* paste the full link of the course-info page of the course. (
              ex: https://edyst.com/course-info/codevita )</small
            ></label
          >
          <input
            id="button-link"
            v-model="currentCard.buttonLink"
            type="url"
            required
            name="button-link"
            title="Add link here."
            placeholder="Add link for the button here."
          />
        </div>
        <div v-if="currentCard.buttonText !== undefined">
          <label for="card-button-text">
            Text to show on the button
            <small class="text-red ml-2">
              * please make it short ( max 21 chars )</small
            >
          </label>
          <input
            id="card-button-text"
            v-model="currentCard.buttonText"
            type="text"
            maxlength="21"
            required
            name="card-button-text"
            title="Add text that will show up on the button"
          />
        </div>
        <div v-if="currentCard.designation !== undefined">
          <label for="designation">Designation</label>
          <input
            id="designation"
            v-model="currentCard.designation"
            type="text"
            name="designation"
            placeholder="Software Developer, Edyst"
            title="Student's role with the name of company, for ex: Software Developer, Edyst."
          />
        </div>
        <Testimonials
          title="Preview card"
          :testimonials="[allCards[cardIndex]]"
        />
        <button
          class="rm-card-btn btn btn-warn block bg-red text-center leading-normal rounded-sm cursor-pointer text-white block p-2 m-auto"
          title="Remove this card from carousel."
          @click.prevent="removeCard"
        >
          Delete
        </button>
        <div class="flex flex-wrap upload-btn-container">
          <button
            class="block btn img-upload-btn"
            :disabled="!currentCard.heading"
            title="Uplaod card's thumbnail for larger screen."
            @click.prevent="prepareCloudinaryWidget('', 'primary-image')"
          >
            <img
              src="https://res.cloudinary.com/edyst/image/upload/v1562748022/admin-page/monitor.svg"
              class="img-upload-logo"
            />
            Thumbnail Web
          </button>
          <button
            class="block btn img-upload-btn"
            :disabled="!currentCard.heading"
            title="Uplaod card's thumbnail for mobile screen."
            @click.prevent="prepareCloudinaryWidget('', 'primary-image-mobile')"
          >
            <img
              src="https://res.cloudinary.com/edyst/image/upload/v1562748022/admin-page/mobile-icon.png"
              class="img-upload-logo"
            />
            Thumbnail mobile
          </button>
          <button
            v-if="currentCard.company_img !== undefined"
            class="block btn img-upload-btn"
            :disabled="!currentCard.heading"
            title="Upload logo of the company."
            @click.prevent="prepareCloudinaryWidget('', 'company-logo')"
          >
            <img
              src="https://res.cloudinary.com/edyst/image/upload/v1562675152/admin-page/image-upload_kgluvk.png"
              class="img-upload-logo"
            />
            Upload company logo
          </button>
        </div>
      </form>
      <div class="flex">
        <button
          v-if="editorType === 'testimonial-card-editor'"
          :disabled="!isEnabled"
          class="preview-btn block m-auto p-2 btn"
          title="Preview on the carousel"
          @click="$emit('DATA_UPDATED', allCards)"
        >
          <img
            src="https://res.cloudinary.com/edyst/image/upload/v1562677361/admin-page/preview.svg"
            class="img-upload-logo"
          />
          Web Preview
        </button>
        <button
          v-if="editorType === 'testimonial-card-editor'"
          :disabled="!isEnabled"
          class="preview-btn block m-auto p-2 btn"
          title="Preview on the carousel"
          @click.prevent="$emit('MOBILE_PREVIEW', allCards)"
        >
          <img
            src="https://res.cloudinary.com/edyst/image/upload/v1562748022/admin-page/mobile-icon.png"
            class="img-upload-logo"
          />
          Mobile Preview
        </button>
      </div>
      <button
        :disabled="!isEnabled"
        class="btn publish-btn block"
        title="Publish for production, please double check your changes before final publish."
        @click="submitDataToParent"
      >
        <img
          src="https://res.cloudinary.com/edyst/image/upload/v1562677280/admin-page/publish.png"
          class="img-upload-logo"
        />
        Publish
      </button>
      <div v-if="isWidgetOpen && publicId !== ''" class="image-upload-widget">
        <AWSS3UploadWidget
          :serverUrl="serverUrl"
          :dropZoneTitle="dropZoneTitle"
          :category="imageUploadConfig.uploadFolder"
          @FILE_UPLOAD_SUCCESS="handleImageUpload"
          @CLOSE_BUTTON_CLICK="handleCancellation"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AWSS3UploadWidget from "@edyst/shared-components/src/components/AWSS3UploadWidget"
import Testimonials from "@edyst/shared-components/src/components/Testimonials"
import siteConfig from "@/utils/siteConfig"
import { youtube_parse_video_id_from_url } from "@/components/YoutubeLiveSessionsEditor/youtubeUtil"

export default {
  components: {
    Testimonials,
    AWSS3UploadWidget,
  },
  props: {
    jsonData: {
      type: Array,
      default() {
        return null
      },
    },
  },
  data() {
    const data = {}
    data.serverUrl = `${siteConfig.siteURL}uploads/public`
    data.allCards = JSON.parse(JSON.stringify(this.jsonData))
    data.currentCard = data.allCards[0]
    data.cardIndex = 0
    data.isWidgetOpen = false
    data.publicId = null
    data.imageUploadConfig = {
      publicId: null,
      uploadFolder: null,
      imageType: null, // primary-image, company-logo
    }
    data.editorType = ""
    data.testimonialCardType = ""
    data.newCardType = "card-with-link"
    data.newTestimonialCardAddition = false
    data.position = ""
    data.dropZoneTitle = "Drag and drop to upload image!"

    return data
  },
  computed: {
    isEnabled() {
      return Object.keys(this.currentCard).every(
        item => this.currentCard[item] !== ""
      )
    },
  },
  watch: {
    jsonData(newData) {
      if (newData !== undefined) {
        this.allCards = JSON.parse(JSON.stringify(newData))
        if (this.allCards.length > 0) {
          this.currentCard = this.allCards[this.cardIndex]
        }
        this.setTestimonialCardType()
      }
    },
  },
  async created() {
    const formData = new FormData()
    formData.append("filePath", "test file path.jpg")
    formData.append("contentType", "image/jpeg")
    formData.append("category", "test")
    // dropzone isn't handling 401 error, so making this call here to
    // validate the token
    const res = await this.axios({
      url: this.serverUrl,
      method: "POST",
      headers: {
        Accept: "application/json",
        "x-access-token": localStorage.token,
      },
      data: formData,
    })
    // if the token ins't valid redirect to login page
    if (res.status !== 200 && res.statusText !== "OK") {
      this.$route.push({ name: "Login" })
      return
    }
    if (this.$route.name === "TestimonialCarouselAdminPage") {
      this.editorType = "testimonial-card-editor"
    }
    if (this.$route.name === "YoutubeSessionUpdateAdminPage") {
      this.editorType = "youtube-session-editor"
    }
  },
  methods: {
    getDescriptionLength(string) {
      const el = document.createElement("div")
      el.innerHTML = string.trim()
      return el.innerText.length >= 300
    },
    handleSubmit() {
      this.$emit("DATA_UPDATED", this.allCards)
    },
    goToPreviousCard() {
      if (this.cardIndex > 0) {
        this.cardIndex -= 1
        this.currentCard = this.allCards[this.cardIndex]
      }
      if (this.editorType === "testimonial-card-editor") {
        this.setTestimonialCardType()
      }
    },
    goToNextCard() {
      if (this.cardIndex < this.allCards.length - 1) {
        this.cardIndex += 1
        this.currentCard = this.allCards[this.cardIndex]
      }
      if (this.editorType === "testimonial-card-editor") {
        this.setTestimonialCardType()
      }
    },
    setTestimonialCardType() {
      if (this.currentCard.externalLink !== undefined) {
        this.testimonialCardType = "card-with-link"
      } else if (this.currentCard.buttonLink !== undefined) {
        this.testimonialCardType = "card-with-button"
      } else if (this.currentCard.designation !== undefined) {
        this.testimonialCardType = "student-card"
      } else if (this.currentCard.additionalInfo !== undefined) {
        this.testimonialCardType = "plain-text-card"
      }
    },
    prepareNewCard(position) {
      if (this.editorType === "youtube-session-editor") {
        const emptyCard = { title: "", link: "", thumbnail: "" }
        this.addNewCard(emptyCard, position)
      } else if (this.editorType === "testimonial-card-editor") {
        this.newTestimonialCardAddition = true
        this.position = position
        // const emptyCard = this.getNewTestimonialCard()
      }
    },
    getNewTestimonialCard() {
      const cardTemplate = {
        heading: "",
        description: "",
        profile_img: "",
        profile_img_mobile: "",
      }
      if (this.newCardType === "card-with-link") {
        cardTemplate.externalLink = ""
      } else if (this.newCardType === "card-with-button") {
        cardTemplate.buttonText = ""
        cardTemplate.buttonLink = ""
      } else if (this.newCardType === "student-card") {
        cardTemplate.designation = ""
        cardTemplate.company_img = ""
      } else if (this.newCardType === "plain-text-card") {
        cardTemplate.additionalInfo = ""
      }
      cardTemplate.type = this.newCardType
      this.addNewCard(cardTemplate, this.position)
      this.newTestimonialCardAddition = false
    },
    addNewCard(newCard, position) {
      if (position === "left" && this.cardIndex === 0) {
        this.allCards.unshift(newCard)
      } else if (position === "left" && this.cardIndex !== 0) {
        this.allCards.splice(this.cardIndex, 0, newCard)
      } else {
        this.allCards.splice(this.cardIndex + 1, 0, newCard)
        this.cardIndex += 1
      }
      this.currentCard = this.allCards[this.cardIndex]
      this.setTestimonialCardType()
    },
    handleNewCardSelection(e) {
      this.newCardType = e.target.id
      this.getNewTestimonialCard()
    },
    handleCardTypeChange() {
      const currentCardData = {
        heading: this.currentCard.heading,
        description: this.currentCard.description,
        profile_img: this.currentCard.profile_img,
        profile_img_mobile: this.currentCard.profile_img_mobile,
      }
      if (this.testimonialCardType === "card-with-link") {
        currentCardData.externalLink = ""
      } else if (this.testimonialCardType === "card-with-button") {
        currentCardData.buttonText = ""
        currentCardData.buttonLink = ""
      } else if (this.testimonialCardType === "student-card") {
        currentCardData.designation = ""
        currentCardData.company_img = ""
      } else if (this.testimonialCardType === "plain-text-card") {
        currentCardData.additionalInfo = ""
      }

      this.allCards[this.cardIndex] = currentCardData
      this.allCards[this.cardIndex].type = this.testimonialCardType
      this.currentCard = this.allCards[this.cardIndex]
    },
    removeCard() {
      this.$swal({
        title: "",
        text: "Are you sure you want to remove the card?",
        icon: "warning",
        buttons: {
          end: {
            text: "Remove",
            value: "remove",
            className: "bg-red",
          },
          cancel: true,
        },
      }).then(value => {
        if (value === "remove") {
          if (this.cardIndex === this.allCards.length - 1) {
            this.allCards.splice(this.cardIndex, 1)
            this.cardIndex -= 1
            this.currentCard = this.allCards[this.cardIndex]
          } else {
            this.allCards.splice(this.cardIndex, 1)
            this.currentCard = this.allCards[this.cardIndex]
          }
          if (this.editorType === "testimonial-card-editor") {
            this.setTestimonialCardType()
          }
        }
      })
      //
    },
    requestSignature(params) {
      return this.axios({
        method: "post",
        url: `${siteConfig.siteURL}users/profile/upload_image`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: params,
      })
    },
    handleImageUpload(awsImageUrl) {
      if (awsImageUrl) {
        setTimeout(() => {
          this.isWidgetOpen = false
        }, 1000)
        if (awsImageUrl) {
          if (this.editorType === "youtube-session-editor") {
            // saving the full path
            this.allCards[this.cardIndex].thumbnail = awsImageUrl
          } else if (this.editorType === "testimonial-card-editor") {
            if (this.imageUploadConfig.imageType === "company-logo") {
              this.allCards[this.cardIndex].company_img = awsImageUrl
            } else if (
              this.imageUploadConfig.imageType === "primary-image-mobile"
            ) {
              this.allCards[this.cardIndex].profile_img_mobile = awsImageUrl
            } else {
              this.allCards[this.cardIndex].profile_img = awsImageUrl
            }
          }
          this.$noty.success("Image Upload successful", {
            layout: "bottomLeft",
            theme: "relax",
            timeout: 1000,
          })
        }
      }
    },
    prepareCloudinaryWidget(link = "", imageType = "") {
      if (this.editorType === "youtube-session-editor") {
        this.imageUploadConfig.publicId = youtube_parse_video_id_from_url(link)
        this.imageUploadConfig.uploadFolder = "youtube-live-sessions"
        this.dropZoneTitle = "Drag and drop to upload YouTube thumbnail!"
        this.isWidgetOpen = true
      } else if (this.editorType === "testimonial-card-editor") {
        this.imageUploadConfig.uploadFolder = "testimonial-card-carousel"
        if (imageType === "company-logo") {
          this.imageUploadConfig.publicId = `${this.currentCard.heading}-company-logo`
          this.dropZoneTitle = "Drag and drop to upload company logo!"
        } else if (imageType === "primary-image-mobile") {
          this.imageUploadConfig.publicId = `${this.currentCard.heading}-primary-image-mobile`
          this.dropZoneTitle = "Drag and drop to upload mobile thumbnail!"
        } else {
          this.imageUploadConfig.publicId = `${this.currentCard.heading}-primary-image`
          this.dropZoneTitle = "Drag and drop to upload web thumbnail!"
        }
        this.imageUploadConfig.imageType = imageType
        this.isWidgetOpen = true
      }
    },
    handleCancellation() {
      this.isWidgetOpen = false
    },
    setAsCurrentCard(idx) {
      this.cardIndex = idx
      this.currentCard = this.allCards[idx]
      this.setTestimonialCardType()
    },
    submitDataToParent() {
      this.$swal({
        title: "",
        text:
          "You're going to publish for production, If you're not sure, please double check all your changes.",
        icon: "warning",
        buttons: {
          end: {
            text: "Yes I'm confident",
            value: "publish",
            className: "bg-green",
          },
          cancel: true,
        },
      }).then(value => {
        if (value === "publish") {
          this.$emit("PUBLISH_DATA", this.allCards)
        }
      })
    },
  },
}
</script>

<style scoped>
.image-upload-widget {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
}

.editor-container {
  position: relative;
  width: 100%;
  max-width: 900px;
  margin: auto;
  padding: 20px;
  border-radius: 2px;
  box-shadow: 0 2px 5px 0px #555555;
}
.img-upload-btn:disabled {
  cursor: not-allowed;
}
button:disabled {
  cursor: not-allowed;
}
.publish-btn:disabled {
  cursor: not-allowed;
}
.upload-btn-container {
  max-width: 620px;
  margin: auto;
}
.left {
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
}

.right {
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
.input-boxes {
  display: block;
  box-sizing: border-box;
  width: 80%;
  margin: auto;
  padding: 10px;
}
.input-boxes > form {
  display: block;
  margin: auto;
}
.input-boxes > form > input,
.input-boxes > form > textarea,
div > input {
  box-sizing: border-box;
  width: 100%;
  margin: 5px;
  padding: 8px;
  border: none;
  border: 1px solid white;
  border-radius: 3px;
  color: #636363;
  box-shadow: 0 1px 3px 0 #575757;
}

.input-boxes > form > input:focus,
.input-boxes > form > textarea:focus,
div > input:focus {
  border: 1px solid #1db6ff;
}

.card-selector {
  margin: 5px;
}
.card-selector > select {
  padding: 5px;
  border: 1px solid white;
  border-radius: 3px;
  color: #636363;
  background-color: white;
  box-shadow: 0 1px 3px 0 #575757;
}

.card-selector > select:focus {
  border: 1px solid #1db6ff;
}
.thumbnail-preview {
  display: block;
  width: 100%;
  max-width: 350px;
  height: auto;
  margin: 10px auto;
}
.thumbnail-preview > img {
  width: 100%;
  height: auto;
}

.rm-card-btn {
  width: 100px;
  height: auto;
}

.btn-icon {
  height: 50px;
  color: grey;
  font-size: 45px;
  text-align: center;
  cursor: pointer;
}
.btn {
  width: 200px;
  height: auto;
  margin: 10px auto;
  padding: 5px;
  border-radius: 2px;
  color: white;
  background-color: #39be70;
  box-shadow: 0 2px 3px 0 #575757;
  text-shadow: none;
  font-weight: 500;
}
.preview-btn {
  background-color: #a100a1;
}
.img-upload-btn {
  background-color: #31c2fe;
}
.btn-warn {
  margin: 10px auto;
  background-color: #ff0000;
  box-shadow: 0 2px 3px 0 #575757;
}
.btn:disabled {
  background-color: #aaaaaa;
}
.pagination-container {
  display: flex;
  overflow-x: auto;
  box-sizing: border-box;
  width: 100%;
  margin: auto;
  padding: 0 15px 15px;
  flex-flow: row;
}
.item-no {
  box-sizing: border-box;
  width: 25px;
  height: 25px;
  margin: 4px;
  padding: 2px;
  border-radius: 100%;
  color: #515151;
  background-color: #eaeaea;
  box-shadow: 0 1px 3px 0 #575757;
  text-shadow: none;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  cursor: pointer;
  flex-shrink: 0;
}

.item-no:hover {
  background-color: lightgrey;
}

.pagination-container::-webkit-scrollbar {
  height: 10px;
}
.new-card-selector {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  width: 100%;
  max-width: 400px;
  height: auto;
  max-height: 300px;
  margin: auto;
  border-radius: 3px;
  background: white;
  box-shadow: 0 10px 30px 5px #4d4d4d;
  text-align: center;
  transform: translate(-50%, -50%);
  animation: fadeIn 0.2s ease-out;
}
.selector-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
}

.card-item {
  margin: 5px;
  padding: 15px;
  border: 1px solid lightgrey;
  border-radius: 4px;
  cursor: pointer;
}
.card-item:hover {
  background-color: #e6e6e6;
}

.img-upload-logo {
  display: block;
  width: 25px;
  height: 25px;
  margin: auto;
  filter: invert(1);
}
</style>
